import styled from "styled-components";
import { theme } from "../../../../../../constants/StyledComponents";

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
export const StyledContainer = styled.div<{
  $hasFooter: boolean;
  $hasMessageBox: boolean;
}>`
  overflow-y: auto;
  height: ${({ $hasFooter, $hasMessageBox }) =>
    $hasFooter
      ? $hasMessageBox
        ? "calc(100dvh - 490px)"
        : "calc(100dvh - 416px)"
      : "calc(100dvh - 329px)"};
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid ${theme.colors.purple_2};
  padding: 20px;
  border-radius: 12px;
`;

export const StyledSubgroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledSubgroupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 25px;
`;

export const StyledIndicatorRow = styled.div<{ $isEven?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 20px;
  border-radius: 12px;
  background-color: ${({ $isEven }) =>
    $isEven ? theme.colors.purple_5 : theme.colors.white};
`;

export const StyledIndicatorValue = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: end;
  width: 250px;
`;

export const StyledCompletedCount = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 273px;
  border: 1px solid #ece8fc;
  border-radius: 6px;
  padding: 10px 20px 10px 20px;
`;

export const StyledMessageBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 8px;
  background-color: ${theme.colors.purple_5};
  margin-bottom: 32px;
`;
